const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let mockWindow;

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&')
};

function createRegExp(str) {let escapedStr, names;
  escapedStr = escapeRegExp(str);
  names = [];
  escapedStr = escapedStr.replace(/\:(\w+)/g, (_a, b) => {
    names.push(b);
    return '([\\w\\.\\-\\_]+)'
  });
  return ({ regexp: `^${escapedStr}`, names })
};

mockWindow = ({
  addEventListener: () => {},
  location: ({ pathname: '/' }),
  history: ({ pushState: () => {} })
});

class Router {
  constructor(initial, state, global=mockWindow) {
    this.routes = [];
    this.state = state;
    this.state.$.router = this;
    this.global = global;
    global.addEventListener('popstate', (e) => {let matchedRoute;
      if (e.state === null) {
        initial && initial();
      } else {
        matchedRoute = this.routes.find(
          (route) =>route.path === e.state.path);
        matchedRoute && matchedRoute.handler(e.state.params, this.state);
      }
    });
  }

  init() {
    this.go(this.global.location.pathname, true);
  }

  add(route) {
    let { regexp, names } = createRegExp(route.path);
    route.reg = new RegExp(regexp);
    route.params = names;
    this.routes.push(route);
  }

  match(path) {let m, params, matchedRoute;
    m = null;
    params = ({});
    matchedRoute = this.routes.find((route) => {
      m = path.match(route.reg);
      if (m) {
        if (route.params) {
          let __1 = route.params; let index=0; for(; index < __1.length; index++) { let value = __1[index];
            params[value] = m[1 + index];
          };
        }
        return true
      }
    });
    if (matchedRoute) {
      return ({ route: matchedRoute, params: params })
    }
  }

  async go(path, push=true) {let m;
    m = this.match(path);
    if (!m) {
      console.log(`No route for path ${path}`);
      return 
    }
    if (push) {
      this.global.history.pushState(({
          name: m.route.name,
          path: m.route.path,
          params: m.params
        }),
        m.route.name, path);
    }
    if (m.route.handler) {
      await m.route.handler(m.params, this.state);
    }
  }

 }

module.exports = { escapeRegExp, createRegExp, mockWindow, Router };
